import axios, { AxiosResponse } from "axios";
import { ResourcePreSignedModel } from "../models/application";
import { BaseResponse } from "../models/base";

export const fetchPresignedUrl = async (body: FormData) => {
  try {
    const data: AxiosResponse<BaseResponse<ResourcePreSignedModel>> =
      await axios.post(
        `${import.meta.env.VITE_BASE_URL}/admin/campaign/get/presigned`,

        body,
        {
          headers: {
            Authorization: localStorage.getItem("userId"),
          },
        }
      );

    if (data.data.responseInfo.httpCode === 200) {
      return data.data.data;
    }

    throw Error(data.data.responseInfo.message);
  } catch (error) {}
};

export const uploadResume = async (url: string, payload: FormData) => {
  try {
    const response: AxiosResponse<any> = await axios.post(
      url,

      payload,
      {}
    );

    if (response.status === 204) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error during upload resume:", error);
    return false;
  } finally {
  }
};

export const registerEmirati = async (payload: {}) => {
  try {
    const response = await axios.post(
      `${import.meta.env.VITE_BASE_URL}/admin/campaign/create/job/seeker`,

      payload,
      {
        headers: {
          Authorization: localStorage.getItem("userId"),
        },
      }
    );
    if (response.data.statusCode === "OK") {
      return true;
      // localStorage.setItem("companyName", response.data.data.companyName);
    } else {
      return false;
    }
  } catch (error) {
    console.error("Error during campaign form submit:", error);
    return false;
  } finally {
  }
};
